import { render, staticRenderFns } from "./UnanswerCalling.vue?vue&type=template&id=ecfb85de&scoped=true"
import script from "./UnanswerCalling.vue?vue&type=script&lang=js"
export * from "./UnanswerCalling.vue?vue&type=script&lang=js"
import style0 from "./UnanswerCalling.vue?vue&type=style&index=0&id=ecfb85de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfb85de",
  null
  
)

export default component.exports